import { render, staticRenderFns } from "./ProjectFile.vue?vue&type=template&id=aca6a362&"
import script from "./ProjectFile.vue?vue&type=script&lang=js&"
export * from "./ProjectFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports